import React from "react";
import DataTable from "react-data-table-component";
import { toast } from "react-hot-toast";
import { tableCustomStyles, tableConfig } from "./config";
import Loading from "../../utils/Loader/Loading";

const ReactDataTable = ({ columns, data, pending, ...rest }) => {
  const isArray = Array.isArray(data);

  // if (!isArray) {
  //     toast.error('Your Provided Data is not na Array');
  // }

  return (
    <DataTable
      columns={columns}
      data={isArray ? data : []}
      striped
      highlightOnHover
      responsive
      pagination
      config={tableConfig}
      dense
      progressPending={pending}
      customStyles={tableCustomStyles}
      progressComponent={<Loading />}
      persistTableHead
      {...rest}
    />
  );
};

export default ReactDataTable;
